import React, {Component} from 'react';
import '../App.css';
  

import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import UpperBarLogin from './UpperBarLogin.component'
import { LoginStatus, SmsStatus } from '../utils/constUtils'
import IdCardLogin from './IdCardLogin.component';
import SmsLogin from './SmsLogin.component';



class LoginPage extends Component {

    unsubscribeService = null;
    state = {    
        loading:false,
        loginLocked: false,     
        EmployeeCardNum:'',
        EmployeeIdNum:'',
        CellNumberMask:'',
        smsSent : false,
        errorMsg : '',
        onceTimeCode:''
    }

        

    
    setEmployeeCardNum = (val) =>  {        
        this.setState({EmployeeCardNum:val});  
    } 

    setEmployeeIdNum = (val) =>  {        
        this.setState({EmployeeIdNum:val});  
    } 


    
    setUserOnceTimeSmsCode = (val) =>  {        
        this.setState({onceTimeCode:val});  
    }  


    saveToken = (userToken) => {
        sessionStorage.setItem('token', JSON.stringify(userToken));    
    };

    saveSToken = (userToken) => {
        sessionStorage.setItem('stoken', JSON.stringify(userToken));    
    };
    


    doLogin = (data) => {

        this.setState({loading:true});
        console.log('LoginPage doLogin' ,data);

        let employeeCardNum = data.employeeCardNum;
        let employeeIdNum = data.employeeIdNum;
        let codeOverSms = data.codeOverSms;
  

        this.setState({ EmployeeIdNum: employeeIdNum }); 

        if (employeeCardNum.length == 0 || employeeIdNum.length == 0)
        {
            this.setState({ errorMsg: 'יש להזין נתונים.' }); 
            return;
        }

        const { nofeshService } = this.props;
        nofeshService.loginUser(employeeCardNum,employeeIdNum,codeOverSms).then(res  => {
            console.log('LoginPage loginUser' ,res);


            if (res.data.Loggedin == LoginStatus.FailedTimeRequests) {       
                this.setState({ loginLocked: true });
            }

            if (res.data.Loggedin == LoginStatus.LoginOK) {       
                this.setState({ smsSent: true });
                this.setState({ CellNumberMask: res.data.CellNumberMask });
                this.setState({ EmployeeCardNum: res.data.EmployeeCardNum }); 
                this.setState({ errorMsg: '' });  
            }

            if (res.data.Loggedin == LoginStatus.NotLoggedIn) { 
                this.setState({ errorMsg: 'הנתונים לא תואמים, כדאי לנסות שוב' });
                let num = this.state.attemptFailed + 1;
                this.setState({ attemptFailed: num });
            }

            if (res.data.Loggedin == LoginStatus.NotEmailFound) { 
                this.setState({ errorMsg: 'לא נמצא דוא"ל תקין במערכת.' });
                let num = this.state.attemptFailed + 1;
                this.setState({ attemptFailed: num });
            }
            this.setState({loading:false}); 
  
        });      
    }



    sendCodeSms = (data) => {

        this.setState({loading:true});
        //work.
        let employeeCardNum = this.state.EmployeeCardNum;
        let employeeIdNum = this.state.EmployeeIdNum;
        let onceTimeCode = data.onceTimeCode;
        

        const { nofeshService } = this.props;
        nofeshService.sendCodeSms(employeeCardNum,employeeIdNum,onceTimeCode).then(res  => {
            console.log('LoginPage sendCodeSms' ,res);

            if (res.data.Loggedin == SmsStatus.CodeCurrect) {


                /*
                const token =  {
                    token: res.data.stoken
                };
                */
                
                const token =  {
                    token: res.data.token
                };              
                const stoken =  {
                    stoken: res.data.stoken
                };
                this.saveToken(token); 
                this.saveSToken(stoken); 
                this.props.onLoggedInRefresh();
            }
    
            if (res.data.Loggedin == SmsStatus.CodeWrong) {
                this.setState({ errorMsg: 'הקוד שהוזן שגוי, אנא הזן שנית.' }); 
            }

            if (res.data.Loggedin == SmsStatus.FailedTimeRequests) {
                this.setState({ loginLocked: true });
            }

            if (res.data.Loggedin == SmsStatus.TimeEnded) {
                this.setState({ loginLocked: true });
            }
            this.setState({loading:false}); 
        });      
    }    
    
    

    render() {     

        
    
        return (                  
            <div>                                   
                <div className="hp_banner">
                    <UpperBarLogin />
                    
                        <div className="cntered-flex" >                
                            <div className="hp_login_box3">                    
                                <div className="hp_search_title">
                                    <div className="hp_search_title_inner_div">
                                        <div className="paddingTop15">כניסה למערכת</div>
                                    </div>
                                </div>		

                                <div className="hp_search_pad1_line"></div>
                                <div className="hp_login_box_pad1"></div>                            
   


                                        {(this.state.loginLocked) ? 
                                            <div className="cntered-flex" >
                                                <div className="directionRtl">
                                                    הנתונים לא תואמים.
                                                    <br />
                                                    פנה למנהל המערכת.
                                                </div>
                                            </div>
                                        : 
                                        
                                             (!this.state.smsSent) ? 
                                            <IdCardLogin 
                                                errorMsg={this.state.errorMsg}
                                                doLogin={this.doLogin}
                                                loading={this.state.loading}
                                                >
                                            </IdCardLogin>  
                                            : 
                                        
                                            <SmsLogin
                                                errorMsg={this.state.errorMsg}
                                                CellNumberMask={this.state.CellNumberMask}
                                                sendCodeSms={this.sendCodeSms} 
                                                codeOverSms={this.state.codeOverSms} 
                                                loading={this.state.loading}>
                                            </SmsLogin>
                                        }


   
                            </div>
                        </div>                                              
                </div>

                <div className="hp_container"></div>
                <div className="hp_footer">
                </div>            
            </div>
        )
    }
}


export default compose(
    withNofeshService()
  )(LoginPage);


